import { render, staticRenderFns } from "./BottomNavigationMenu.vue?vue&type=template&id=8aaed60a&scoped=true"
import script from "./BottomNavigationMenu.vue?vue&type=script&lang=js"
export * from "./BottomNavigationMenu.vue?vue&type=script&lang=js"
import style0 from "./BottomNavigationMenu.vue?vue&type=style&index=0&id=8aaed60a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aaed60a",
  null
  
)

export default component.exports